import { useTenant } from '../../contexts/TenantContext';

export default function TermsPage() {
  const tenant = useTenant();

  return (
    <div
      className="min-h-screen py-12 px-4"
      style={{
        background: tenant.theme.colors.gradients.main,
        fontFamily: tenant.theme.fonts.body.family
      }}
    >
      <div className="max-w-4xl mx-auto">
        <div
          className="p-8 rounded-lg shadow-lg"
          style={{
            background: 'rgba(17, 24, 39, 0.95)',
            border: '1px solid rgba(51, 65, 85, 0.5)'
          }}
        >
          <h1
            className="text-4xl font-bold mb-6"
            style={{
              fontFamily: tenant.theme.fonts.primary.family,
              color: tenant.theme.colors.accent
            }}
          >
            Términos y Condiciones
          </h1>

          <div className="space-y-6 text-gray-200 leading-relaxed">
            <p className="text-sm text-gray-400">
              Última actualización: Febrero 2026
            </p>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                1. Aceptación de los Términos
              </h2>
              <p>
                Al acceder y utilizar <strong style={{ color: tenant.theme.colors.accent }}>Neureka</strong>,
                aceptas estar legalmente vinculado por estos Términos y Condiciones. Si no estás de acuerdo
                con alguna parte de estos términos, no debes utilizar nuestros servicios.
              </p>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                2. Descripción del Servicio
              </h2>
              <p>
                Neureka es una plataforma de entrenamiento cognitivo que ofrece:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li>Acceso a 17 juegos de lógica diferentes</li>
                <li>Sistema de seguimiento de progreso personal</li>
                <li>Herramientas para profesionales de la salud mental</li>
                <li>Gestión de sesiones presenciales y remotas</li>
                <li>Estadísticas detalladas de rendimiento</li>
              </ul>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                3. Registro y Cuenta de Usuario
              </h2>
              <p>Para utilizar Neureka, debes:</p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li>Tener al menos 13 años de edad</li>
                <li>Proporcionar información veraz y actualizada durante el registro</li>
                <li>Mantener la confidencialidad de tu contraseña</li>
                <li>Notificarnos inmediatamente de cualquier uso no autorizado de tu cuenta</li>
                <li>Ser responsable de todas las actividades realizadas bajo tu cuenta</li>
              </ul>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                4. Uso Aceptable
              </h2>
              <p>Te comprometes a NO:</p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li>Utilizar el servicio para fines ilegales o no autorizados</li>
                <li>Intentar acceder a áreas no autorizadas del sistema</li>
                <li>Interferir con el funcionamiento del servicio o servidores</li>
                <li>Realizar ingeniería inversa, descompilar o desensamblar el código</li>
                <li>Compartir tu cuenta con terceros</li>
                <li>Utilizar bots, scripts o automatización para manipular resultados</li>
                <li>Copiar, modificar o distribuir el contenido sin autorización</li>
              </ul>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                5. Propiedad Intelectual
              </h2>
              <p>
                <strong>Neureka:</strong> El nombre, logo, diseño y código de la plataforma son propiedad
                exclusiva de Neureka y están protegidos por leyes de propiedad intelectual.
              </p>
              <p className="mt-3">
                <strong>Juegos de Lógica:</strong> Los juegos implementados (Sudoku, Hitori, Nurikabe, etc.)
                son de dominio público en su concepto original. Nuestra implementación específica, algoritmos
                de generación y diseño visual son propiedad de Neureka.
              </p>
              <div
                className="mt-4 p-4 rounded-lg"
                style={{ background: 'rgba(15, 23, 42, 0.6)' }}
              >
                <h3 className="font-semibold mb-2" style={{ color: tenant.theme.colors.accent }}>
                  Atribuciones
                </h3>
                <p className="text-sm">
                  Reconocemos que los juegos de lógica japoneses como Sudoku, Hitori, Kakuro, Nurikabe,
                  y otros tienen sus orígenes en publicaciones como Nikoli y son parte del patrimonio
                  cultural de los puzzles lógicos.
                </p>
              </div>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                6. Cuentas Profesionales
              </h2>
              <p>
                Los usuarios con cuentas profesionales (psicólogos, terapeutas) se comprometen a:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li>Poseer las credenciales profesionales necesarias en su jurisdicción</li>
                <li>Utilizar las herramientas de forma ética y responsable</li>
                <li>Obtener el consentimiento informado de sus pacientes</li>
                <li>Proteger la confidencialidad de los datos de sus pacientes</li>
                <li>Cumplir con las regulaciones profesionales y legales aplicables</li>
              </ul>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                7. Limitación de Responsabilidad
              </h2>
              <p>
                Neureka se proporciona "tal cual" y "según disponibilidad". No garantizamos que:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li>El servicio estará disponible de forma ininterrumpida o libre de errores</li>
                <li>Los resultados obtenidos sean precisos o confiables en todos los casos</li>
                <li>El entrenamiento cognitivo produzca resultados específicos</li>
              </ul>
              <p className="mt-3">
                <strong>Neureka NO es un sustituto de servicios médicos o psicológicos profesionales.</strong>
                Nuestras herramientas son complementarias y no deben usarse como único método de diagnóstico
                o tratamiento.
              </p>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                8. Modificaciones del Servicio
              </h2>
              <p>
                Nos reservamos el derecho de:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li>Modificar o discontinuar el servicio (temporal o permanentemente)</li>
                <li>Cambiar las características, funcionalidades o precios</li>
                <li>Actualizar estos términos y condiciones</li>
              </ul>
              <p className="mt-3">
                Te notificaremos de cambios significativos con al menos 30 días de antelación.
              </p>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                9. Cancelación y Terminación
              </h2>
              <p>
                Puedes cancelar tu cuenta en cualquier momento desde tu perfil. Nos reservamos el derecho
                de suspender o terminar tu cuenta si:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li>Violas estos Términos y Condiciones</li>
                <li>Realizas actividades fraudulentas o ilegales</li>
                <li>Comprometes la seguridad del servicio</li>
              </ul>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                10. Ley Aplicable y Jurisdicción
              </h2>
              <p>
                Estos términos se rigen por las leyes de España. Cualquier disputa se resolverá en los
                tribunales competentes de [tu ciudad/provincia].
              </p>
            </section>

            <section>
              <h2
                className="text-2xl font-semibold mb-3"
                style={{ color: tenant.theme.colors.primary }}
              >
                11. Contacto
              </h2>
              <p>
                Para preguntas sobre estos términos, contacta con:
              </p>
              <div
                className="mt-3 p-4 rounded-lg"
                style={{ background: 'rgba(15, 23, 42, 0.6)' }}
              >
                <p><strong>Email:</strong> legal@neureka.es</p>
                <p><strong>Formulario:</strong> <a href="/contact" className="underline" style={{ color: tenant.theme.colors.accent }}>Página de contacto</a></p>
              </div>
            </section>

            <section className="pt-6 border-t border-gray-700">
              <p className="text-center text-gray-400 text-sm">
                Al utilizar Neureka, aceptas estos Términos y Condiciones en su totalidad.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
